export var ClientBaseAnswerValue = /* @__PURE__ */ ((ClientBaseAnswerValue2) => {
  ClientBaseAnswerValue2["B2C"] = "B2C";
  ClientBaseAnswerValue2["B2B"] = "B2B";
  ClientBaseAnswerValue2["Both"] = "Both";
  return ClientBaseAnswerValue2;
})(ClientBaseAnswerValue || {});
